import { render } from "./Questions2.vue?vue&type=template&id=1a9283fb&scoped=true"
import script from "./Questions2.vue?vue&type=script&lang=js"
export * from "./Questions2.vue?vue&type=script&lang=js"

import "./Questions2.vue?vue&type=style&index=0&id=1a9283fb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a9283fb"]])

export default __exports__